import React from 'react'

const News = () => {
  return (
    <div className='news'>
        <h1>NewsFeeds feature will be added soon!</h1>
        <p>Stay Tuned for the updates about BlueLoop</p>
        <img src="./Assets/stay-tuned.png" alt="" />
    </div>
  )
}

export default News